import React from "react";

const Java_RegEx = () => {
  return (
    <div>
      <h1>Java RegEx</h1>
      <p>This page provides explanations, examples, and common use-cases for Java RegEx in Java.</p>
    </div>
  );
};

export default Java_RegEx;
